<template>
  <div class="column full-height justify-center items-center">
    <q-spinner-ball color="primary" size="4em" />
    <div class="q-my-md">{{ t('common.signingIn') }}</div>
    <Transition appear>
      <div v-if="longSignInMessageVisible">
        {{ t('common.longSignInMessage') }}
      </div>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { ref, onUnmounted } from 'vue';
import { useAuthentication } from '@/composables/auth/useAuthentication';
import { useI18n } from 'vue-i18n';

const { logout } = useAuthentication();
const { t } = useI18n();
const longSignInMessageVisible = ref(false);

const longMessageTimeout = setTimeout(() => {
  longSignInMessageVisible.value = true;
}, 9 * 1000);
const logoutTimeout = setTimeout(() => logout(true), 20 * 1000);

onUnmounted(() => {
  clearTimeout(longMessageTimeout);
  clearTimeout(logoutTimeout);
});
</script>
